import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {
    async [actionTypes.PROJETO.BUSCAR_PROJETOS](context, filtro) {
        const {data} = await api.projeto.buscarProjetos(filtro)
        return data
    }
}
